import { render } from "./KeywordTitleView.vue?vue&type=template&id=553cf9dc&ts=true"
import script from "./KeywordTitleView.vue?vue&type=script&lang=ts"
export * from "./KeywordTitleView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__